exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pLweabSbINawgRz7-rNfr {\n    box-sizing: content-box;\n    margin: 60px 0;\n    width: 100%;\n    position: relative;\n}\n\n._255AzBAp9kBQqUkit8e75G {\n    margin-bottom: 32px;\n}\n\n.FgGuaQxJuJzqb_Nr6BQRJ {\n    display: flex;\n    justify-content: center;\n}\n\n.FgGuaQxJuJzqb_Nr6BQRJ > * {\n    height: 100%;\n    width: 100%;\n    max-width: 1075px;\n}\n", ""]);

// exports
exports.locals = {
	"root": "pLweabSbINawgRz7-rNfr",
	"text": "_255AzBAp9kBQqUkit8e75G",
	"image": "FgGuaQxJuJzqb_Nr6BQRJ"
};